module.exports = __webpack_public_path__ + "static/img/ping_bg.4dd51a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ping_bg.jpg
// module id = 6LR4
// module chunks = 1